export default Object.freeze({
  INVALID_GANG_SHEET: "invalid_gang_sheet",
  INVALID_WIDTH: "invalid_width",
  INVALID_HEIGHT: "invalid_height",
  NEGATIVE_VALUES: "negative_values",
  MIN_PRINT_SIZE: "min_print_size",
  MAX_PRINT_SIZE: "max_print_size",
  MAX_PRINT_SIZE_PRINT_AS_IS: "max_print_size_print_as_is",
  UPSCALE_THRESHOLD_EXCEEDED: "upscale_threshold_exceeded"
});
